// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'

import { Media } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { NavContainer } from '../../../brunswick/containers/NavContainer'
import { useSearchOverlayContext } from '../../../containers/SearchOverlayContext'
import { disableScroll, enableScroll } from '../../../lib/utils'

import { MobileSearch } from './MobileSearch'
import { NavHeaderCenter } from './NavHeaderCenter'
import { NavHeaderIcons } from './NavHeaderIcons'
import { NavHeaderLeft } from './NavHeaderLeft'
import { Body, ScreenReaderOnlyLink, Wrapper } from './styles'

const hiddenMobileSearchRoutes = ['international-checkout']

export const NavHeader: FC = () => {
  const {
    magnolia: { navigation: strings },
  } = useTranslation()
  const { isHeaderPushedUp, setIsHeaderPushedUp, promoBarIsOpen } = NavContainer.useContainer()
  const router = useRouter()

  const { shouldDisplaySearchOverlay } = useSearchOverlayContext()
  const isFadedOut = shouldDisplaySearchOverlay
  const freezeTabId = shouldDisplaySearchOverlay ? 'search' : undefined

  // Whether the current page has a filter navbar (i.e. search, collections)
  const isDesktopFilterPage = useMemo(() => {
    return router.pathname.includes('collections') || router.pathname.includes('search')
  }, [router.pathname])

  const currentPage = router.query?.handle?.toString() || router.route || ''
  const showMobileSearch = !hiddenMobileSearchRoutes.includes(currentPage)

  // Hide header when scrolling down

  const [searchResults, setSearchResults] = useState<boolean>(false)

  const onAutoComplete = () => {
    if (router.pathname !== '/search') {
      setSearchResults(true)
    }
  }

  const onClearFormClick = () => {
    setSearchResults(false)
    setIsHeaderPushedUp(false)
  }

  const onFormSubmit = useCallback((searchText: string) => {
    router
      .push({
        pathname: '/search',
        query: { q: searchText },
      })
      .then(() => {
        setSearchResults(false)
      })
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickSearchOverlayProduct = () => {
    setSearchResults(false)
  }

  useEffect(() => {
    searchResults ? disableScroll() : enableScroll()
  }, [searchResults])

  return (
    <>
      <Wrapper
        isCollectionsPage={isDesktopFilterPage}
        pushedUp={isHeaderPushedUp}
        promoBarIsOpen={promoBarIsOpen}
        data-testid='site-header'
        role='banner'
      >
        <Body>
          <Link href='/pages/accessibility' legacyBehavior passHref>
            <ScreenReaderOnlyLink href='/pages/accessibility'>
              {strings.accessibilityLink}
            </ScreenReaderOnlyLink>
          </Link>

          <NavHeaderLeft isFadedOut={isFadedOut} />
          <NavHeaderCenter isFadedOut={isFadedOut} />
          <NavHeaderIcons freezeTabId={freezeTabId} />
        </Body>
      </Wrapper>
      {showMobileSearch && (
        <Media lessThan='md'>
          <MobileSearch
            onAutoComplete={onAutoComplete}
            onClearFormClick={onClearFormClick}
            onClickSearchOverlayProduct={onClickSearchOverlayProduct}
            onFormSubmit={onFormSubmit}
            searchResults={searchResults}
            pushedUp={isHeaderPushedUp}
          />
        </Media>
      )}
    </>
  )
}
